const GZ_ROUTE_TO_LABEL: Record<string, string> = {
  '': 'Plus Landing',
  'value-bets': 'Scommesse di Valore',
  trends: 'Trend',
  'betting-splits': 'Scelte degli scommettitori',
  'match-centre': 'Match Center',
};

export function toPascalCase(label: string): string {
  if (!label) return '';

  return label
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
}

export function getTabNameFromPath(pathname: string): string | null {
  const plusSegmentMatch = pathname.match(/\/plus(?:\/([^/]+))?/);
  if (!plusSegmentMatch) return null;

  const routeSegment = plusSegmentMatch[1] ?? '';
  const label = GZ_ROUTE_TO_LABEL[routeSegment];

  return label ? toPascalCase(label) : null;
}
